// extracted by mini-css-extract-plugin
export default {"disableHighlight":"CountrySelect_disableHighlight__NREiZ","empty":"CountrySelect_empty__MJq60"};